import { render, staticRenderFns } from "./SurveyManagementEditingQuestion.vue?vue&type=template&id=7995d622&scoped=true&"
import script from "./SurveyManagementEditingQuestion.vue?vue&type=script&lang=js&"
export * from "./SurveyManagementEditingQuestion.vue?vue&type=script&lang=js&"
import style0 from "./SurveyManagementEditingQuestion.vue?vue&type=style&index=0&id=7995d622&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7995d622",
  null
  
)

/* custom blocks */
import block0 from "./SurveyManagementEditingQuestion.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7995d622')) {
      api.createRecord('7995d622', component.options)
    } else {
      api.reload('7995d622', component.options)
    }
    module.hot.accept("./SurveyManagementEditingQuestion.vue?vue&type=template&id=7995d622&scoped=true&", function () {
      api.rerender('7995d622', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/survey-management/edit-question/SurveyManagementEditingQuestion.vue"
export default component.exports